


































import { setJwt } from "../token";
import gql from "graphql-tag";
import jwtExpiredMessage from "@/frontend/mixins/jwtExpiredMessage";

import formButton from "@/frontend/components/form/formButton.vue";
import formInput from "@/frontend/components/form/formInput.vue";
import formLink from "@/frontend/components/form/formLink.vue";
import otherLink from "@/frontend/components/form/otherLink.vue";
import panelHeader from "@/frontend/components/form/panelHeader.vue";

export default {
  components: {
    formButton,
    formInput,
    formLink,
    otherLink,
    panelHeader,
  },
  mixins: [jwtExpiredMessage],
  props: {
    viewOtherLink: {
      type: Boolean,
      default: true,
    },
    viewCreateAccountLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formName: "ruleForm",
      // checked: false, for remember me
      isError: false,
      ruleForm: {
        userId: "",
        userPassword: "",
      },
    };
  },
  computed: {
    rules() {
      const checkField = (rule, value, callback) => {
        if (value === "" || this.isError) {
          callback(new Error(this.errorText));
        } else {
          callback();
        }
      };
      return {
        userId: [{ validator: checkField, trigger: "blur" }],
        userPassword: [{ validator: checkField, trigger: "blur" }],
      };
    },
    errorText() {
      return this.isError
        ? this.$t("form.incorrect")
        : this.$t("form.inputField");
    },
  },
  methods: {
    signin() {
      this.isError = false;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          console.log("update");
          this.update();
        } else {
          console.log("input error");
          return false;
        }
      });
    },
    async update() {
      let response;
      try {
        response = await this.$apollo.mutate({
          mutation: gql`
            mutation TokenAuth($userId: String!, $userPassword: String!) {
              tokenAuth(username: $userId, password: $userPassword) {
                token
                user {
                  isActive
                }
              }
            }
          `,
          variables: {
            userId: this.ruleForm.userId,
            userPassword: this.ruleForm.userPassword,
          },
        });
      } catch (e) {
        this.signinError();

        let message = this.$t("signin.errorMessage.tokenAuth");
        this.$message({
          showClose: true,
          message,
          type: "error",
        });
        return;
      }

      const token =
        response.data &&
        response.data.tokenAuth &&
        response.data.tokenAuth.token;

      const isActive =
        response.data &&
        response.data.tokenAuth &&
        response.data.tokenAuth.user.isActive;

      if (!isActive) {
        let message = this.$t("signin.errorMessage.notActive");
        this.$message({
          showClose: true,
          message,
          type: "error",
        });
        return;
      }

      if (token) {
        setJwt(token);
        await this.$store.dispatch("fetchUser");
        this.$message({
          message: this.$t("signin.successMessage"),
          type: "success",
        });
        if (this.$store.state.signinNextRoute) {
          this.redirect({ path: this.$store.state.signinNextRoute.path });
        } else {
          this.redirect({ path: "/" });
        }
      } else {
        this.signinError();
      }
    },
    redirect(nextRoute) {
      if (nextRoute) {
        this.$router.push({ ...nextRoute });
      } else {
        this.$router.push({ name: "landing" });
      }
      this.$store.commit("signinNextRoute", null);
    },
    signinError() {
      this.isError = true;
      this.ruleForm.userPassword = "";
      this.$refs[this.formName].validateField("userId");
      this.$refs[this.formName].validateField("userPassword");
    },
  },
};
